export const changePasswordRoutes = {
  CHANGE_PASSWORD: "/user/reset", // PUT -> body: { password, passwordRepeat } (новый API)
};
